package it.neckar.lizergy.model

import it.neckar.lizergy.model.financial.economics.EquityFinanced
import it.neckar.lizergy.model.financial.economics.FinancingType
import it.neckar.lizergy.model.financial.economics.Leveraged
import it.neckar.lizergy.model.price.AvailableProducts
import it.neckar.lizergy.model.price.PriceList
import it.neckar.lizergy.model.price.ProductResolver
import it.neckar.lizergy.model.price.StaticPriceList
import it.neckar.lizergy.model.project.process.state.AdvanceInvoiceProcessStateEntry
import it.neckar.lizergy.model.project.process.state.AssemblyBasementPreparationProcessStateEntry
import it.neckar.lizergy.model.project.process.state.AssemblyBasementProcessStateEntry
import it.neckar.lizergy.model.project.process.state.AssemblyPortfolioProcessStateEntry
import it.neckar.lizergy.model.project.process.state.AssemblyRoofPreparationProcessStateEntry
import it.neckar.lizergy.model.project.process.state.AssemblyRoofProcessStateEntry
import it.neckar.lizergy.model.project.process.state.BlueprintAcquisitionProcessStateEntry
import it.neckar.lizergy.model.project.process.state.BlueprintProcessStateEntry
import it.neckar.lizergy.model.project.process.state.ConfigurationProcessStateEntry
import it.neckar.lizergy.model.project.process.state.DocumentationProcessStateEntry
import it.neckar.lizergy.model.project.process.state.FinalAccountProcessStateEntry
import it.neckar.lizergy.model.project.process.state.FinishingUpProcessStateEntry
import it.neckar.lizergy.model.project.process.state.GridAssessmentProcessStateEntry
import it.neckar.lizergy.model.project.process.state.OrderSpecialMaterialProcessStateEntry
import it.neckar.lizergy.model.project.process.state.PresentationProcessStateEntry
import it.neckar.lizergy.model.project.process.state.ProjectProcessStateEntry
import it.neckar.lizergy.model.project.process.state.QuoteConfirmationProcessStateEntry
import it.neckar.lizergy.model.project.process.state.QuoteOfferProcessStateEntry
import it.neckar.lizergy.model.project.process.state.StartupOperationsProcessStateEntry
import it.neckar.lizergy.model.project.process.state.SwitchMeterBoxProcessStateEntry
import it.neckar.lizergy.model.state.ProcessStateEntry
import it.neckar.open.kotlin.serializers.JsonInclusionStrategy
import it.neckar.open.kotlin.serializers.defaultJsonConfiguration
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonBuilder
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.SerializersModuleBuilder
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass

/**
 * Contains the kotlinx serialization configuration for the planner
 */
fun SerializersModuleBuilder.plannerSerializationModel() {

  polymorphic(AvailableProducts::class) {
    subclass(StaticPriceList::class)
  }
  polymorphic(ProductResolver::class) {
    subclass(StaticPriceList::class)
  }
  polymorphic(PriceList::class) {
    subclass(StaticPriceList::class)
  }

  polymorphic(FinancingType::class) {
    subclass(EquityFinanced::class)
  }
  polymorphic(FinancingType::class) {
    subclass(Leveraged::class)
  }

  polymorphic(ProcessStateEntry::class) {
    subclass(AdvanceInvoiceProcessStateEntry::class)
    subclass(AssemblyBasementProcessStateEntry::class)
    subclass(AssemblyBasementPreparationProcessStateEntry::class)
    subclass(AssemblyPortfolioProcessStateEntry::class)
    subclass(AssemblyRoofProcessStateEntry::class)
    subclass(AssemblyRoofPreparationProcessStateEntry::class)
    subclass(BlueprintAcquisitionProcessStateEntry::class)
    subclass(BlueprintProcessStateEntry::class)
    subclass(ConfigurationProcessStateEntry::class)
    subclass(DocumentationProcessStateEntry::class)
    subclass(FinalAccountProcessStateEntry::class)
    subclass(FinishingUpProcessStateEntry::class)
    subclass(GridAssessmentProcessStateEntry::class)
    subclass(OrderSpecialMaterialProcessStateEntry::class)
    subclass(PresentationProcessStateEntry::class)
    subclass(ProjectProcessStateEntry::class)
    subclass(QuoteConfirmationProcessStateEntry::class)
    subclass(QuoteOfferProcessStateEntry::class)
    subclass(StartupOperationsProcessStateEntry::class)
    subclass(SwitchMeterBoxProcessStateEntry::class)
  }
}

/**
 * contains the default properties and serializer module for lizergy
 * @see JsonBuilder
 * */
fun JsonBuilder.plannerJsonConfiguration(prettyPrintEnabled: Boolean = true) {
  defaultJsonConfiguration(inclusionStrategy = JsonInclusionStrategy.EncodeDefaultsIncludeNulls, prettyPrintEnabled = prettyPrintEnabled)
  serializersModule = SerializersModule {
    plannerSerializationModel()
  }
}

/**
 * Shared [Json] instance configured for the planner.
 *
 * Use this together with an explicitly provided serializer (e.g. via `HttpResponse.plannerBody`)
 * instead of Ktor's reflective `.body()` decoding. See #2098: on Kotlin/JS, Ktor resolves the
 * serializer reflectively from `TypeInfo`, which mis-resolves sealed `RestResponse` types in the
 * full planner-ui browser bundle (the class discriminator `type` is then reported as an unknown key).
 */
val plannerJson: Json = Json { plannerJsonConfiguration() }
